import Slider from '@mui/material/Slider';
import UiCurrrencyInput from './UiCurrrencyInput';

const UiRangeSlider = ({ min, max, values, onChange, name, placeholder}) => {
  
  return (
    <div className="uiSlider">
      <div className='uiSlider__placeholder'>{placeholder}</div>
      <div className="uiSlider__inputs">
        <UiCurrrencyInput
          min={min}
          max={max}
          value={name === "sumDeals" ? Math.round(values[0]) : Math.round(values[0])}
          onChange={value => {
            let v = value;
            if (v < min) v = min;
            if (v > values[1]) v = values[1];
            onChange([v, Math.round(values[1])]);
          }}
        />
        <UiCurrrencyInput
          min={min}
          max={max}
          value={name === "sumDeals" ? Math.round(values[1]) : Math.round(values[1])}
          onChange={value => {
            let v = value;
            if (v > max) v = max;
            if (v < values[0]) v = values[0];
            onChange([values[0], v]);
          }}
        />
      </div>

      <div className="uiSlider__slider">
        <Slider
          min={min}
          max={max}
          value={values}
          onChange={(_, v) => onChange(v)}
        />
      </div>
    </div>
  );
};

export default UiRangeSlider;